// If used in a form, match value to the key below
export const recipients: Record<string, string> = {
  contactUs: "contactus@specsnightlife.com",
  contactForm: "jbrackeen@specsonline.com",
  onlineOrder: "contactus@specsnightlife.com",
  inStoreShopping: "customerservice@specsonline.com",
  giftCard: "contactus@specsnightlife.com",
  stockTheBar: "iod@specsonline.com",
  wineClub: "wineclub@specsonline.com",
  website: "webmaster@specsonline.com, websupport@leetilford.com, ux@leetilford.com",
  specsStore: "rms@specsonline.com",
  liquorDept: "liquorcontact@specsonline.com",
  wineDept: "winecontact@specsonline.com",
  beerDept: "beercontact@specsonline.com",
  groceryDept: "delicontact@specsonline.com",
  charity: "corporategiving@specsonline.com",
  employment: "jobs@specsonline.com",
  realEstate: "realestate@specsonline.com",
  wholesale: "wholesalecontact@specsonline.com",
  keyclub: "keyclub@specsonline.com",
  rewards: "keyclub@specsonline.com",
  bordeauxOrder: "futures@specsonline.com",
  partySupplyOrder: "orders@sfcdistributors.com, websupport@leetilford.com",
  newProductSubmission: "stevejabour@specsonline.com",
};

export const mockRecipients: Record<string, string> = {
  contactUs: "andrea.johnson+contactus@leetilford.com, david.dennis+contactus@leetilford.com",
  contactForm: "andrea.johnson+contactform@leetilford.com, david.dennis+contactform@leetilford.com",
  onlineOrder: "andrea.johnson+CurbsideSupport@leetilford.com, david.dennis+CurbsideSupport@leetilford.com",
  inStoreShopping: "andrea.johnson+customerservice@leetilford.com, david.dennis+customerservice@leetilford.com",
  giftCard: "andrea.johnson+giftcards@leetilford.com, david.dennis+giftcards@leetilford.com",
  stockTheBar: "andrea.johnson+iod@leetilford.com, david.dennis+iod@leetilford.com",
  wineClub: "andrea.johnson+wineclub@leetilford.com, david.dennis+wineclub@leetilford.com",
  website: "andrea.johnson+webmaster@leetilford.com, david.dennis+webmaster@leetilford.com",
  specsStore: "andrea.johnson+rms@leetilford.com, david.dennis+rms@leetilford.com",
  liquorDept: "andrea.johnson+liquorcontact@leetilford.com, david.dennis+liquorcontact@leetilford.com",
  wineDept: "andrea.johnson+winecontact@leetilford.com, david.dennis+winecontact@leetilford.com",
  beerDept: "andrea.johnson+beercontact@leetilford.com, david.dennis+beercontact@leetilford.com",
  groceryDept: "andrea.johnson+delicontact@leetilford.com, david.dennis+delicontact@leetilford.com",
  charity: "andrea.johnson+corporategiving@leetilford.com, david.dennis+corporategiving@leetilford.com",
  employment: "andrea.johnson+jobs@leetilford.com, david.dennis+jobs@leetilford.com",
  realEstate: "andrea.johnson+realestate@leetilford.com, david.dennis+realestate@leetilford.com",
  wholesale: "andrea.johnson+wholesalecontact@leetilford.com, david.dennis+wholesalecontact@leetilford.com",
  keyclub: "andrea.johnson+keyclub@leetilford.com, david.dennis+keyclub@leetilford.com",
  rewards: "andrea.johnson+keyclub@leetilford.com, david.dennis+keyclub@leetilford.com",
  bordeauxOrder: "carrie.wilson+bordeaux@leetilford.com, david.dennis+bordeaux@leetilford.com",
  partySupplyOrder: "carrie.wilson+partysupply@leetilford.com, david.dennis+partysupply@leetilford.com",
  newProductSubmission: "carrie.wilson+newproduct@leetilford.com, david.dennis+newproduct@leetilford.com",
};
